import React from 'react'

import { VideoComponents } from '@cvg/react-components'
import ExpandIcon from '@components/Icons/ExpandIcon'

const { VideoPlayer, VIDEO_PROVIDER } = VideoComponents

import styles from './styles.module.css'

const Media = ({ media, isModal, ...rest }) => {
  const [mediaType] = media.file.contentType.split('/')
  const imgSrc = media.file.url + (isModal ? '' : '?fm=jpg&q=50&h=300')

  return (
    <figure className={styles.media} data-modal={isModal}>
      {mediaType === 'image' && (
        <>
          <img alt='Image from post' loading='lazy' src={imgSrc} />
          <a href={imgSrc} target='_blank' rel='noreferrer'>
            <ExpandIcon />
          </a>
        </>
      )}

      {mediaType === 'video' && (
        <VideoPlayer preload='metadata' videoType={VIDEO_PROVIDER.url} videoUrl={media.file.url + '#t=0.001'} {...rest} />
      )}
    </figure>
  )
}

export default Media
